import { Text } from '@fluentui/react-components';
import { AlertRegular, ErrorCircleRegular, HatGraduationRegular } from '@fluentui/react-icons';
import { find } from 'lodash';
import moment from 'moment-timezone';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TimetablePeriodTimeProps } from './TimetablePeriod.interface';
import { isExam } from './TimetablePeriod.utils';

/**
 * Displays the time and period of the given event
 */
export const TimetablePeriodTime: FC<TimetablePeriodTimeProps> = ({
  eventData,
  timeTableLesson,
  substitution,
  lessonPattern,
}) => {
  const { t } = useTranslation();
  const start = moment(eventData.startStr).format('HH:mm');
  const end = moment(eventData.endStr).format('HH:mm');

  /**
   * (Units-) Name of the cardinal number the current period
   */
  const cardinalNumberDescr = useMemo(() => {
    const pattern = find(lessonPattern, {
      cardinalNumber: timeTableLesson?.cardinalNumber,
    });

    if (pattern === undefined) {
      return `${timeTableLesson?.cardinalNumber}. ${t('timetable:period_time:period', { defaultValue: 'Stunde' })}`;
    }

    return pattern.title;
  }, [lessonPattern, t, timeTableLesson?.cardinalNumber]);

  return (
    <div className="flex items-center fc-event-time-container">
      {substitution && (timeTableLesson === null || !timeTableLesson.event) && (
        <ErrorCircleRegular className="substitutionExclamationIcon" />
      )}
      {timeTableLesson && (
        <>
          {isExam(timeTableLesson, substitution) && <HatGraduationRegular className="examIcon" />}
          {timeTableLesson.event && <AlertRegular className="eventIcon" />}
        </>
      )}
      <Text className="fc-event-time" size={200} weight="regular">
        {`${cardinalNumberDescr} ${start} - ${end}`}
      </Text>
    </div>
  );
};
